/**
 * Data Parser Utility
 * Extracted from TeamGanttImporter.tsx
 * Handles resource and predecessor parsing from CSV data
 */

/**
 * Parse resources (comma-separated assignees)
 * Input: "John Doe, Jane Smith, Bob Johnson"
 * Output: ["John Doe", "Jane Smith", "Bob Johnson"]
 */
export function parseResources(resourcesStr: string): string[] {
  if (!resourcesStr || resourcesStr.trim() === '') return [];
  return resourcesStr.split(',').map(r => r.trim()).filter(r => r.length > 0);
}

/**
 * Parse predecessors (dependencies)
 * Input: "1.2, 1.3, 2.1"
 * Output: ["1.2", "1.3", "2.1"]
 */
export function parsePredecessors(predecessorsStr: string): string[] {
  if (!predecessorsStr || predecessorsStr.trim() === '') return [];
  return predecessorsStr.split(',').map(p => p.trim()).filter(p => p.length > 0);
}
